import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Beneficiaries/**`. */
const BeneficiariesNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="BENEFICIARY_CREATED"
				title="Dossier créé"
				message="Le dossier a bien été créé."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_UPDATED"
				title="Dossier modifié"
				message="Le dossier a bien été modifié."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_ARCHIVED"
				title="Dossier archivé"
				message="Le dossier a bien été archivé."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_DELETED"
				title="Dossier supprimé"
				message="Le dossier a bien été supprimé."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_STAFF_MEMBERS_UPDATED"
				title="Personnel du dossier enregistré"
				message="Le personnel du dossier a bien été enregistré."
			/>
			<SuccessNotification
				eventName="INTERVIEW_DELETED"
				title="Entretien supprimé"
				message="L'entretien a été supprimé du dossier."
			/>
			<ErrorNotification
				eventName="INTERVIEW_DELETION_FAILED"
				title="Erreur"
				message="L'entretien n'a pas pu être supprimé."
			/>
			<ErrorNotification
				eventName="BENEFICIARIES_FETCH_FAILED"
				title="Erreur"
				message="La liste des dossiers n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_FETCH_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être chargé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_CREATION_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être créé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_UPDATE_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_ARCHIVE_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être archivé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_DELETION_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être supprimé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_STAFF_MEMBERS_UPDATE_FAILED"
				title="Erreur"
				message="Le personnel du dossier n'a pas pu être enregistré."
			/>
		</React.Fragment>
	);
};

export default BeneficiariesNotifications;
